export type PublicAdminAuthSettings = {
  enableTwoFA?: boolean;
  enableCaptcha?: boolean;
  title?: string;
  subtitle?: string;
};

export type PublicAuthSettingsResponse = {
  adminAuth?: PublicAdminAuthSettings;
};

const DEFAULT: PublicAuthSettingsResponse = {
  adminAuth: { enableTwoFA: false, enableCaptcha: true },
};

export async function getPublicAuthSettings(): Promise<PublicAuthSettingsResponse> {
  try {
    const res = await fetch('/api/public/auth-settings', {
      headers: { Accept: 'application/json' },
      credentials: 'include',
    });
    if (!res.ok) return DEFAULT;
    const data = await res.json();
    return {
      adminAuth: {
        enableTwoFA: data?.adminAuth?.enableTwoFA === true,
        enableCaptcha: data?.adminAuth?.enableCaptcha !== false,
        title: data?.adminAuth?.title,
        subtitle: data?.adminAuth?.subtitle,
      },
    };
  } catch {
    return DEFAULT;
  }
}
